export const filterTypes = {
  MODEL_AUTOCOMPLETE: "MODEL_AUTOCOMPLETE",
  API_AUTOCOMPLETE: "API_AUTOCOMPLETE",
  RADIO_GROUP: "RADIO_GROUP",
  SELECT: "SELECT",
  SWITCH: "SWITCH",
  DATE_PICKER: "DATE_PICKER",
  LOAD_OPTIONS: "LOAD_OPTIONS",
};
